{
  "Full name": "Толық аты-жөні",
  "Password": "Құпия сөз",
  "Invitations": "Шақырулар",
  "Welcome": "Қош келдіңіз",
  "Have an account?": "Аккаунтыңыз бар ма?",
  "Change language": "Тілді өзгерту",
  "Settings": "Параметрлер",
  "Log out": "Шығу",
  "Sign in": "Кіру",
  "Sign up": "Тіркелу",
  "auth/invalid-credential": "Жарамсыз деректер",
  "auth/user-not-found": "Пайдаланушы табылған жоқ",
  "auth/wrong-password": "Қате пошта немесе құпия сөз",
  "auth/email-already-in-use": "Бұл электрондық пошта мекенжайы қолданыста",
  "auth/weak-password": "Әлсіз құпия сөз",
  "auth/too-many-requests": "Көп сұраныс жасалды. Кейінірек қайталаңыз",
  "auth/invalid-email": "Жарамсыз электрондық пошта",
  "auth/user-disabled": "Пайдаланушының есептік жазбасы өшірілген",
  "auth/requires-recent-login": "Бұл әрекетті орындау үшін соңғы кіріс қажет",
  "auth/network-request-failed": "Желі сұранысы сәтсіз аяқталды",
  "auth/operation-not-allowed": "Әрекетке рұқсат жоқ",
  "auth/account-exists-with-different-credential": "Есептік жазба басқа деректермен тіркелген",
  "Theme": "Жарық режимі",
  "Employees": "Қызметкерлер",
  "Add new employee": "Жаңа қызметкер қосу",
  "Add": "Қосу",
  "Edit": "Өңдеу",
  "Delete": "Жою",
  "Invite": "Шақыру",
  "BoardScreen": "Техникалық тапсырмалар",
  "BoardScreenAdmin": "Басқару тақтасы",
  "BoardScreenExecutor": "Басқару тақтасы",
  "InventoryScreen": "Инвентарь",
  "RentalsScreen": "Жалдау",
  "RentalPointsScreen": "Жалдау нүктелері",
  "ClientsScreen": "Клиенттер",
  "ChatScreen": "Чат",
  "WarehouseScreen": "Қойма",
  "Ready for rent": "Жалдауға дайын",
  "Ready for issue": "Беруге дайын",
  "To be decommissioned": "Жоюға жіберу",
  "Functional": "Жарамды",
  "Needs repair": "Жөндеуді қажет етеді",
  "Faulty": "Ақаулы",
  "Under inspection": "Тексеруде",
  "Accepted after rent": "Жалдаудан кейін қабылданды",
  "Tool name": "Құрал атауы",
  "Description": "Сипаттама",
  "Visible For Others At": "Басқаларға көрсету уақыты",
  "Undelivered comment": "Неге жеткізілмеді",
  "Price": "Бағасы",
  "SKU": "Артикул",
  "Inventory number": "Инв. нөмірі",
  "Rental point": "Жалдау орны",
  "Status": "Статус",
  "Category": "Санат",
  "Deposit amount": "Депозит сомасы",
  "Purchase price": "Сатып алу бағасы",
  "Source of Acquisition": "Жүзілік көздері",
  "IIN": "ЖСН",
  "Forgot password?": "Құпия сөзді ұмыттыңыз ба?",
  "Confirm Password": "Құпия сөзді растау",
  "Forgot password": "Құпиясөзді қалпына келтіру",
  "Restore": "Қалпына келтіру",
  "Enter your email": "Электрондық поштаңызды енгізіңіз",
  "Create company": "Компания ашу",
  "Select": "Таңдау",
  "Save": "Сақтау",
  "Company name": "Компания аты",
  "Company type": "Компания түрі",
  "Rent": "Жалға беру",
  "Chat": "Чат",
  "Select company": "Компания таңдау",
  "Send": "Жіберу",
  "Name": "Аты",
  "Payment": "Төлем",
  "Subscription": "Абонемент",
  "Valid Until": "Жарамды мерзімі",
  "Remind": "Байланыс (еске салу)",
  "СВБ": "СВБ",
  "Дневной": "Күндізгі",
  "Безлимит": "Шексіз",
  "Created By": "Жасаушы",
  "Channel": "Канал",
  "Branch": "Бөлімше",
  "open": "Ашық",
  "inProgress": "Жұмыс барысында",
  "resolved": "Жабық",
  "Requests": "Сұраныстар",
  "Create new company": "Жаңа компания ашу",
  "List": "Тізім",
  "Board": "Тақта",
  "ID": "Номер",
  "Assignee": "Орындаушы",
  "Email": "Электрондық пошта",
  "User role": "Қолданушы рөлі",
  "Role": "Роль",
  "Company": "Компания",
  "Asker": "Сұраушы",
  "Responder": "Жауап беруші",
  "Admin": "Администратор",
  "asker": "Сұраушы",
  "responder": "Жауап беруші",
  "admin": "Администратор",
  "Select role": "Рөл таңдау",
  "ChatDrawerScreen": "Чаттар",
  "Chats": "Чаттар",
  "Topic": "Канал",
  "Table": "Кесте",
  "Rows per page": "Беттегі жолдар",
  "TicketsScreen": "Сұраныстар",
  "Submit": "Растау",
  "FormScreen": "Енгізу формасы",
  "DetailsScreen": "Толығырақ",
  "CollectionPickerScreen": "Таңдау",
  "Channels": "Каналдар",
  "BranchesScreen": "Филиалдар",
  "TypeScreen": "Мәселелер түрлері",
  "Issue type": "Мәселе түрі",
  "PENDING": "Жауап күтуде",
  "ACCEPTED": "Қабылданды",
  "Submit2": "Сақтау",
  "Accept": "Қабылдау",
  "Decline": "Өшіру",
  "Join to company": "Компанияға қосылу",
  "alertTitle": "Назар аударыңыз",
  "deleteConfirmation": "Сіз оны жойғыңыз келетініне сенімдісіз бе?",
  "cancel": "Бас тарту",
  "confirmDelete": "Иә",
  "Members": "Қатысушылар",
  "Invalid email address": "Пошта форматы қате",
  "Role is required": "Рөлді таңдау керек",
  "Name is required": "Аты міндетті түрде толтырылу керек",
  "Services": "Қызметтер",
  "Additional services": "Қосымша қызметтер",
  "CustomersApplicationsAdmin": "Өтінімдер",
  "CustomersApplications": "Өтінімдер",
  "CustomersApplicationsEmployee": "Өтінімдер",
  "CustomersApplicationsExecutor": "Өтінімдер",
  "Shops": "Дүкендер",
  "Service name": "Қызмет атауы",
  "Installation Type": "Орнату түрі",
  "Conditioner": "Кондиционер",
  "Large household appliances": "Үлкен тұрмыстық техника",
  "Technician visit": "Техникалық сапар",
  "Service price": "Қызмет бағасы",
  "Service description": "Қызмет сипаттамасы",
  "Client should have": "Клиент қосымша өзі сатып алуы керек",
  "Executor should have": "Орындаушы өзімен бірге алып келуі керек",
  "Accessed to": "Келесі дүкендерге қолжетімді",
  "Additional service name": "Қызмет атауы",
  "Measurement unit": "Өлшем бірлігі",
  "Buyer Name": "Сатып алушының аты",
  "Address": "Мекенжай",
  "Seller Name": "Сатушының аты",
  "Shop branch": "Дүкен филиалы",
  "Contact Name": "Байланыс аты",
  "Installation date": "Орнату күні",
  "Additional Services": "Косымша қызметтер",
  "Phone Number": "Телефон нөмірі",
  "KKM Receipt Number": "KKM чек нөмірі",
  "Notes": "Қосымша ақпарат",
  "Add files": "Файлдар қосу",
  "By cash": "Қолма-қол ақша",
  "Executor": "Орындаушы",
  "Total Price": "Жалпы баға",
  "Shop": "Дүкен",
  "Branches": "Филиалдар",
  "Branch name": "Филиал аты",
  "Branch address": "Филиал мекен-жайы",
  "Files": "Файлдар",
  "Incoming": "Келіп түскен",
  "Accepted": "Қабылданды",
  "In progress": "Процесс барысында",
  "Completed": "Аяқталды",
  "Uncompleted": "Аяқталмаған",
  "shopEmployee": "Дүкен қызметшісі",
  "Users": "Пайдаланушылар",
  "executor": "Техникалық орындаушы",
  "operator": "Оператор",
  "lawyer": "Заңгер",
  "courier": "Курьер",
  "customer": "Клиент",
  "sender": "Жіберуші",
  "senderName": "Жіберуші",
  "fullName": "Толық аты-жөні",
  "Intech shop": "Intech дүкен",
  "defaultRole": "Қойылмаған",
  "normal": "Қалыпты",
  "urgent": "Шұғыл",
  "after_19": "19:00-ден кейін",
  "DeliveryBoardScreen": "Жеткізу тақтасы",
  "LawyerBoardScreen": "Заңгер өтінімдері",
  "MyDeliveryRequestsScreen": "Менің жеткізу өтінімдерім",
  "DeliveryZoneMemoryScreen": "Жеткізу аймақтарының жады",
  "DeliveryZonesScreen": "Жеткізу аймақтары",
  "DeliveryStreetsScreen": "Жеткізу көшелері",
  "DeliveryCustomersScreen": "Жеткізу клиенттері",
  "DeliveryNotificationsScreen": "Жеткізу хабарламалары",
  "DeliveryParserScreen": "Импорт",
  "Order Number": "№",
  "Vehicle": "Көлік",
  "Diagnosis": "Ақау",
  "Parts": "Бөлшектер",
  "Mechanic": "Механик",
  "Payment Method": "Төлем әдісі",
  "Make": "Марка",
  "Model": "Модель",
  "Year": "Жылы",
  "VIN": "VIN",
  "License Plate": "Нөмір белгісі",
  "Owner": "Иесі",
  "Service Name": "Қызмет атауы",
  "Duration (hours)": "Ұзақтығы (сағат)",
  "Part Name": "Бөлшек атауы",
  "Quantity in Stock": "Қордағы саны",
  "Storage Location": "Сақтау орны",
  "Diagnosed": "Ақау қойылды",
  "Waiting for Parts": "Бөлшектер күтілуде",
  "Ready for Pickup": "Алуға дайын",
  "Cancelled": "Бас тартылды",
  "cash": "Қолма-қол ақша",
  "halyk": "Halyk",
  "kaspi": "Kaspi",
  "Reports": "Есептер",
  "STOReportsScreen": "СТО есептері",
  "WeeklyReportsList": "Апталық есептер",
  "NewEmployeeForm": "Жаңа қызметкер формасы",
  "list": "Тізім",
  "form": "Форма",
  "chat": "Чат",
  "board": "Тақта",
  "reports": "Есептер",
  "RepairOrdersBoard": "Жөндеу тапсырыстары тақтасы",
  "RepairOrdersList": "Жөндеу тапсырыстары тізімі",
  "MechanicsList": "Механиктер тізімі",
  "VehiclesList": "Көліктер тізімі",
  "ServicesList": "Қызметтер тізімі",
  "InventoryList": "Инвентарь тізімі",
  "CustomerChat": "Клиенттер чаты",
  "Full Name": "Толық аты-жөні",
  "mechanic": "Механик",
  "Mechanics": "Механики",
  "electrician": "Электрик",
  "Roles": "Рөлдер",
  "Add new": "Қосу",
  "Nothing found": "Ештеңе табылмады",
  "Phone number must start with +7 and contain 10 digits after it": "Телефон нөмірі +7-ден басталып, одан кейін 10 саннан тұруы керек",
  "Field is required": "Енгізу өрісі толтырылуы керек",
  "Must be a valid number": "Сан болуы керек",
  "Must select at least one option": "Кемінде бір нұсқаны таңдау керек",
  "An unexpected error occurred. Please try again.": "Күтпеген қате орын алды. Қайталап көріңіз.",
  "Works": "Жұмыстар",
  "paymentType": "Төлем түрі",
  "paymentAmount": "Сома",
  "Remaining Amount": "Қалған сома",
  "Payment Methods": "Төлем түрлері",
  "Payments": "Төлемдер",
  "wheelAlignment": "Дөңгелектердің бұрылысы",
  "engineMechanic": "Моторшы",
  "tireService": "Шина қызметі",
  "generator": "Генератор",
  "generator_starter": "Генератор стартер",
  "starter": "Стартер",
  "All": "Барлығы",
  "Period": "Кезең",
  "Export CSV": "CSV жүктеу",
  "No data": "Деректер жоқ",
  "No records to export": "Жүктеуге жазбалар жоқ",
  "Failed to export CSV": "CSV жүктеу мүмкін болмады",
  "month": "Ай бойынша",
  "quarter": "Тоқсан бойынша",
  "year": "Жыл бойынша",
  "range": "Кезең бойынша",
  "Department": "Бөлімше",
  "Task Type": "Тапсырма түрі",
  "hotel-tasks": "Техникалық",
  "cleaning-tasks": "Клиниң",
  "Task description": "Тапсырма сипаттамасы",
  "technical": "техникалық",
  "one time": "бір-реттік",
  "in progress": "жұмыс барысында",
  "legal_in_work": "Жұмыста",
  "legal_new": "Жаңа",
  "Tasks": "Тапсырмалар",
  "in review": "тексерілісте",
  "legal_completed": "Аяқталды",
  "Deadline": "Мерзімі",
  "Note": "Ескерту",
  "Block": "Блок",
  "Attachments": "Файлдар",
  "blocked": "блокта",
  "First Name": "Есімі",
  "Last Name": "Тегі",
  "Birthday": "Туған күні",
  "cleaning": "Клиниң",
  "Appearance": "Сыртқы көрініс",
  "Switch between light and dark mode": "Жарық және қараңғы тақырып арасында ауысу",
  "Language": "Тіл",
  "Select your preferred language": "Таңдаулы тіліңізді таңдаңыз",
  "Profile Information": "Профиль ақпараты",
  "Avatar": "Аватар",
  "Change name": "Аты-жөнін өзгерту",
  "First name": "Аты",
  "Last name": "Тегі",
  "Cancel": "Бас тарту",
  "Notifications": "Хабарламалар",
  "Display mode": "Қолданба режимі",
  "granted": "Рұқсат етілген",
  "denied": "Бұғатталған",
  "default": "Бұғатталған",
  "standalone": "PWA",
  "browser": "Браузер",
  "dateCreated": "Жасалған күні",
  "dateUpdated": "өзгертілген уақыты",
  "Today": "Бүгін",
  "Count": "Саны",
  "Type": "Түрі",
  "Avg Time (hours)": "Орташа уақыт (сағ)",
  "ExpensesList": "Шығындар",
  "Amount": "Сома",
  "Date": "Күні",
  "MakesList": "Марка тізімі",
  "ModelsList": "Модельдер тізімі",
  "Subscriptions": "Абонементтер",
  "gym_manager": "Спорт зал менеджері",
  "director": "Директор",
  "CleaningBoardScreen": "Клиниң тапсырмалары",
  "ArchivedHotelTasksScreen": "Мұрағатталған тапсырмалар",
  "RecurringTaskTemplatesScreen": "Қайталанатын тапсырма үлгілері",
  "HotelReportsScreen": "Бизнес-орталық есептері",
  "cleaning_manager": "Клиниң менеджері",
  "cleaning_executor": "Клиниң орындаушысы",
  "TechWarehouseScreen": "Техникалық қойма",
  "HotelTenantCompaniesScreen": "Жалға алушы компаниялар",
  "HotelTenantEmployeesScreen": "Жалға алушы қызметкерлері",
  "CleaningWarehouseScreen": "Клиниң қойма",
  "Наименование товара": "Тауар атауы",
  "Количество": "Саны",
  "Описание": "Сипаттама",
  "Расположение": "Орналасуы",
  "Дата создания": "Жасалған күні",
  "FurnitureCraft Pro": "МебельCraft Pro",
  "Furniture": "Мебель",
  "OrdersBoard": "Тапсырыстар тақтасы",
  "CustomersList": "Клиенттер тізімі",
  "ProductsList": "Өнімдер тізімі",
  "MaterialsList": "Материалдар тізімі",
  "DesignsList": "Дизайндар тізімі",
  "FurnitureReportsScreen": "Мебель есептері",
  "furniture-orders": "мебель-тапсырыстар",
  "customers": "клиенттер",
  "furniture-products": "мебель-өнімдер",
  "materials": "материалдар",
  "inventory": "инвентарь",
  "furniture-designs": "мебель-дизайндар",
  "Order #": "Тапсырыс №",
  "Customer": "Клиент",
  "Furniture Items": "Мебель бұйымдары",
  "Custom Design": "Жеке дизайн",
  "Materials": "Материалдар",
  "Labor Cost": "Еңбек ақысы",
  "Delivery Date": "Жеткізу күні",
  "Delivery Address": "Жеткізу мекенжайы",
  "Write in WhatsApp": "WhatsApp-қа жазу",
  "Special Instructions": "Арнайы нұсқаулар",
  "Assigned Craftsman": "Тағайындалған шебер",
  "Assigned Designer": "Тағайындалған дизайнер",
  "Date Created": "Жасалған күні",
  "Submission Date": "Күні",
  "Initiator Full Name": "Бастамшы",
  "Contract Name": "Шарт",
  "Type of Goods/Works/Services": "Тауар/жұмыс/қызмет түрі",
  "legal_goods": "Тауар",
  "legal_works": "Жұмыстар",
  "legal_services": "Қызметтер",
  "Delivery / Execution Terms": "Тауарды, жұмысты немесе қызметті жеткізу/орындау мерзімі",
  "Contract Amount": "Бағасы",
  "VAT Type": "ҚҚС",
  "legal_with_vat": "ҚҚС-пен",
  "legal_without_vat": "ҚҚС-сыз",
  "Payment Procedure": "Төлем тәртібі",
  "legal_prepayment": "Алдын ала төлем",
  "legal_postpayment": "Нақты",
  "Contractor Name": "Орындаушы/мердігер атауы",
  "Contractor Contacts": "Орындаушы/мердігер байланыстары",
  "Commercial Proposal": "Коммерциялық ұсыныс",
  "Comments": "Пікірлер",
  "Archived": "Мұрағатталған",
  "Full Name": "Толық аты-жөні",
  "Tenant company": "Жалға алушы компания",
  "Position": "Лауазымы",
  "Phone Number": "Телефон нөмірі",
  "Email": "Электрондық пошта",
  "Address": "Мекенжай",
  "Preferred Contact": "Таңдаулы байланыс",
  "Customer Notes": "Клиент ескертулері",
  "Product Name": "Өнім атауы",
  "Base Price": "Негізгі баға",
  "Dimensions (L x W x H)": "Өлшемдер (Ұ x Е x Б)",
  "Primary Material": "Негізгі материал",
  "Production Time (days)": "Өндіру уақыты (күн)",
  "Customizable": "Жекешелендірілетін",
  "Product Image": "Өнім суреті",
  "Material Name": "Материал атауы",
  "Material Type": "Материал түрі",
  "Price per Unit": "Бірлік бағасы",
  "Unit": "Бірлік",
  "Supplier": "Жеткізуші",
  "Color": "Түс",
  "Item Name": "Зат атауы",
  "Minimum Stock Level": "Ең төменгі қор деңгейі",
  "Last Restocked": "Соңғы толтырылған",
  "Design Name": "Дизайн атауы",
  "Designer": "Дизайнер",
  "Design Files": "Дизайн файлдары",
  "Template Design": "Үлгі дизайн",
  "Phone": "Телефон",
  "Specialization": "Мамандығы",
  "Living Room": "Үй жиһазы",
  "Bedroom": "Ұйықтайтын бөлме",
  "Dining Room": "Асхана",
  "Kitchen": "Ас үй",
  "Office": "Кеңсе",
  "Outdoor": "Сыртқы",
  "Custom": "Жеке",
  "Chair": "Орындық",
  "Sofa": "Диван",
  "Bed": "Төсек",
  "Cabinet": "Шкаф",
  "Bookshelf": "Кітап сөресі",
  "Desk": "Жұмыс үстелі",
  "Dresser": "Комод",
  "Dining Set": "Асхана жинағы",
  "Coffee Table": "Кофе үстелі",
  "Wardrobe": "Гардероб",
  "Oak": "Емен",
  "Maple": "Қайың",
  "Cherry": "Шие",
  "Walnut": "Жаңғақ",
  "Pine": "Қарағай",
  "Mahogany": "Махагон",
  "Birch": "Қайың",
  "Ash": "Қарағай",
  "MDF": "MDF",
  "Plywood": "Фанера",
  "Glass": "Шыны",
  "Metal": "Металл",
  "Fabric": "Мата",
  "Leather": "Тері",
  "piece": "дана",
  "meter": "метр",
  "square_meter": "шаршы метр",
  "cubic_meter": "текше метр",
  "kg": "кг",
  "liter": "литр",
  "bank_transfer": "Банк аударымы",
  "credit_card": "Несие картасы",
  "installment": "Бөліп төлеу",
  "quote_requested": "Баға сұралды",
  "quote_sent": "Баға жіберілді",
  "order_confirmed": "Тапсырыс расталды",
  "design_phase": "Дизайн кезеңі",
  "production_phase": "Өндіру кезеңі",
  "quality_check": "Сапаны тексеру",
  "ready_for_delivery": "Жеткізуге дайын",
  "delivered": "Жеткізілді",
  "completed": "Аяқталды",
  "cancelled": "Болдырмады",
  "designer": "Дизайнер",
  "craftsman": "Шебер",
  "manager": "Техникалық менеджер",
  "sales": "Сату",
  "customer_service": "Клиент қызметі",
  "quality_control": "Сапаны бақылау",
  "warehouse": "Қойма",
  "Поиск": "Іздеу",
  "FilesScreen": "Файлдар",
  "File name": "Файл атауы",
  "File": "Файл",
  "Photo": "Фото",
  "Added by": "Қосқан",
  "Date added": "Қосылған күні",
  "Download": "Жүктеу",
  "RecurringTasksScreen": "Қайталанатын тапсырмалар",
  "Frequency": "Жиілігі",
  "Activity": "Белсенділік",
  "No activity yet": "Әзірге белсенділік жоқ",
  "cardLog.statusMoved": "{{user}} бұл карточканы: \"{{from}}\" күйінен \"{{to}}\" күйіне ауыстырды",
  "cardLog.updated": "{{user}} карточканы жаңартты",
  "daily": "Күн сайын",
  "weekly": "Апта сайын",
  "monthly": "Ай сайын",
  "annual": "Жыл сайын",
  "TechWarehouseReceiptsScreen": "Тех қойма түсімдері",
  "chatField": {
    "loadingMessages": "Хабарламалар жүктелуде...",
    "noMessages": "Хабарламалар жоқ. Чат бастау үшін басыңыз."
  },
  "Create": "Құру",
  "Create Folder": "Қалта құру",
  "Create New Folder": "Жаңа қалта құру",
  "Delete File": "Файлды жою",
  "Delete Folder": "Қалтаны жою",
  "Are you sure you want to delete this file?": "Бұл файлды жойғыңыз келетініне сенімдісіз бе?",
  "Are you sure you want to delete this folder?": "Бұл қалтаны жойғыңыз келетініне сенімдісіз бе?",
  "File Details": "Файл туралы мәлімет",
  "Actions": "Әрекеттер",
  "File metadata": "Файл метадеректері",
  "Kind": "Түрі",
  "Updated": "Жаңартылды",
  "Share": "Бөлісу",
  "Properties": "Қасиеттері",
  "Rename": "Қайта атау",
  "Save to device storage": "Құрылғыға сақтау",
  "Send to others or apps": "Басқаларға немесе қолданбаларға жіберу",
  "File not found": "Файл табылмады",
  "This file is no longer available.": "Бұл файл енді қолжетімді емес.",
  "Failed to download file. Please try again.": "Файлды ашу мүмкін болмады. Қайталап көріңіз.",
  "Image": "Сурет",
  "Video": "Бейне",
  "Audio": "Аудио",
  "PDF Document": "PDF құжаты",
  "Word Document": "Word құжаты",
  "Spreadsheet": "Кесте",
  "Presentation": "Презентация",
  "Archive": "Мұрағат",
  "Modified unknown": "Өзгертілген уақыты белгісіз",
  "Modified just now": "Жаңа ғана өзгертілді",
  "Modified yesterday": "Кеше өзгертілді",
  "Modified {{count}} hours ago": "{{count}} сағ. бұрын өзгертілді",
  "Modified {{count}} days ago": "{{count}} күн бұрын өзгертілді",
  "Modified {{value}}": "{{value}} өзгертілді",
  "Rename Folder": "Қалтаны қайта атау",
  "Folder Name": "Қалта атауы",
  "Upload File": "Файл жүктеу",
  "Search in Drive": "Файл іздеу",
  "Folders": "Папкалар",
  "Recent Files": "Соңғы файлдар",
  "WarehouseScreen": "Қойма",
  "by car number": "Көлік нөмірі бойынша іздеу",
  "Enter your email.": "Электрондық поштаңызды енгізіңіз.",
  "Password reset link sent to your email.": "Құпиясөзді қалпына келтіру сілтемесі электрондық поштаңызға жіберілді.",
  "Failed to send password reset link. Please check your email and try again.": "Құпиясөзді қалпына келтіру сілтемесін жіберу мүмкін болмады. Электрондық поштаңызды тексеріп, қайта көріңіз.",
  "No company selected": "Компания таңдалмады",
  "Request sent": "Сұраныс жіберілді",
  "Enter company name!": "Компания атауын енгізіңіз!",
  "Select company type!": "Компания түрін таңдаңыз!",
  "Invited successfully!": "Шақыру сәтті жіберілді!",
  "Access denied": "Қатынауға тыйым салынды",
  "Gallery permission is required": "Галереяға рұқсат беру қажет",
  "Upload error": "Жүктеу қатесі",
  "Failed to upload media file.": "Медиафайлды жүктеу мүмкін болмады.",
  "An error occurred": "Қате орын алды",
  "Failed to pick file": "Файлды таңдау кезінде қате орын алды",
  "This file type is not supported on your device": "Бұл файл түріне құрылғыңызда қолдау көрсетілмейді",
  "Failed to open file": "Файлды ашу мүмкін болмады",
  "Error": "Қате",
  "OK": "ОК",
  "Confirm": "Растау",
  "Add checklist": "Тексеру тізімін қосу",
  "Add item": "Тармақ қосу",
  "Administration": "Әкімшілеу",
  "App Updates": "Қолданба жаңартулары",
  "Are you sure you want to delete this employee? This action cannot be undone.": "Бұл қызметкерді жойғыңыз келетініне сенімдісіз бе? Бұл әрекетті болдырмау мүмкін емес.",
  "Audio File": "Аудио файл",
  "Audio playback error": "Аудионы ойнату қатесі",
  "Authentication failed": "Аутентификация сәтсіз аяқталды",
  "Configuration Management": "Конфигурацияны басқару",
  "Create Rent": "Жалдауды құру",
  "Delete Employee": "Қызметкерді жою",
  "Edit Profile": "Профильді өңдеу",
  "EmployeeDetailsScreen": "Қызметкер деректері",
  "employees": "қызметкер",
  "Employees will appear here once they join": "Қызметкерлер қосылғаннан кейін осында көрінеді",
  "Failed to delete employee. Please try again.": "Қызметкерді жою мүмкін болмады. Қайта көріңіз.",
  "Failed to share file": "Файлды бөлісу мүмкін болмады",
  "Hide password": "Құпиясөзді жасыру",
  "Loading employees...": "Қызметкерлер жүктелуде...",
  "Manage app configurations": "Қолданба конфигурацияларын басқару",
  "Media": "Медиа",
  "No employees found": "Қызметкерлер табылмады",
  "No employees yet": "Әзірге қызметкерлер жоқ",
  "Pending Invitations": "Күтілудегі шақырулар",
  "Last login by platform": "Соңғы кірген платформалар бойынша",
  "Sharing is not available on this device": "Бұл құрылғыда бөлісу қолжетімсіз",
  "Show password": "Құпиясөзді көрсету",
  "Signature": "Қолтаңба",
  "Team Members": "Команда мүшелері",
  "Try adjusting your search terms": "Іздеу сұрауын өзгертіп көріңіз",
  "Unknown file type": "Белгісіз файл түрі",
  "Video playback error": "Бейнені ойнату қатесі",
  "Video source error": "Бейне көзінің қатесі",
  "Update Available": "Жаңарту қолжетімді",
  "A new version ({{version}}) is available. Would you like to update now?": "Жаңа нұсқа ({{version}}) қолжетімді. Қазір жаңартқыңыз келе ме?",
  "Later": "Кейін",
  "Update": "Жаңарту",
  "Permission Granted": "Рұқсат берілді",
  "You'll now receive important notifications from the app!": "Енді қолданбадан маңызды хабарламаларды алып отырасыз!",
  "Great!": "Тамаша!",
  "Permission Denied": "Рұқсат берілмеді",
  "To enable notifications, go to Settings > Apps > Tizim > Notifications and turn them on.": "Хабарландыруларды қосу үшін Параметрлер > Қолданбалар > Tizim > Хабарландырулар тармағына өтіп, оларды қосыңыз.",
  "Open Settings": "Параметрлерді ашу",
  "You can enable notifications in Settings > Notifications > Tizim": "Хабарландыруларды Параметрлер > Хабарландырулар > Tizim бөлімінде қоса аласыз",
  "Failed to request notification permission. Please try again.": "Хабарландыруларға рұқсат сұрау мүмкін болмады. Қайта көріңіз.",
  "Notifications are disabled": "Хабарландырулар өшірілген",
  "Notifications not set up": "Хабарландырулар бапталмаған",
  "Error checking permissions": "Рұқсаттарды тексеру қатесі",
  "Enable notifications": "Хабарландыруларды қосыңыз",
  "Requesting...": "Сұралуда...",
  "Enable in Settings": "Параметрлерде қосу",
  "Enable Notifications": "Хабарландыруларды қосу",
  "Stay Updated": "Жаңалықтан хабардар болыңыз",
  "Enable notifications to receive important updates, messages, and alerts from the app.": "Қолданбадан маңызды жаңартуларды, хабарламаларды және ескертулерді алу үшін хабарландыруларды қосыңыз.",
  "Apply Update": "Жаңартуды қолдану",
  "This will restart the app to apply the update. Continue?": "Жаңартуды қолдану үшін қолданба қайта іске қосылады. Жалғастырасыз ба?",
  "Apply": "Қолдану",
  "Version": "Нұсқа",
  "New version": "Жаңа нұсқа",
  "Applying...": "Қолданылуда...",
  "Development Mode": "Әзірлеу режимі",
  "Updates are simulated in development builds. Build a preview/production app to test real updates.": "Әзірлеу жинақтарында жаңартулар модельденеді. Нақты жаңартуларды тексеру үшін preview/production нұсқасын құрастырыңыз.",
  "Runtime": "Орындалу ортасы",
  "Checking...": "Тексерілуде...",
  "Check": "Тексеру",
  "View All": "Барлығын көру",
  "Yes": "Иә",
  "No": "Жоқ",
  "Менеджер связался": "Менеджер связался",
  "Street": "Көше",
  "House Number": "Үй нөмірі",
  "Apartment": "Пәтер",
  "At Home": "Үйде",
  "Not At Home": "Үйде емес",
  "Not Contacted": "Байланыспады",
  "new": "Жаңа",
  "not_delivered": "Жеткізілмеді",
  "normal": "Қалыпты",
  "urgent": "Шұғыл",
  "after_19": "19:00-ден кейін",
  "По дате": "Күні бойынша",
  "Келу күні": "Келу күні",
  "Заттар": "Заттар",
  "Қабылдаған": "Қабылдаған",
  "Ескертпе": "Ескертпе",
  "Товары": "Заттар"
}
